module.exports = window.initializeRemote('app_am_data_management', {"WEBPACK_BUNDLE":true,"WEBPACK_BUILD":true});